module.exports = "/_next/static/images/adjust-limit-1055a5721c0fdf557f1b1b40cc37674e.svg";